export default {
  data: null,
  columns: [
    {
      label: '手机号',
      prop: 'mobile'
    },
    {
      label: '学员姓名',
      prop: 'memberName'
    },
    {
      label: '本期新增购买金额',
      prop: 'periodPurchaseAmount'
    },
    {
      label: '本期新增权益课时',
      prop: 'periodNewHours'
    },
    {
      label: '本期销课课时',
      prop: 'periodConsumedHours'
    },
    {
      label: '本期确认收入',
      prop: 'periodRevenue'
    },
    {
      label: '本期退款',
      prop: 'periodRefundAmount'
    },
    {
      label: '本期补课课时',
      prop: 'makeUpHours'
    }
  ]
}
